import React from 'react';
import Service2 from 'views/Service/Service2';

const ServicePage = () => {
  return <Service2 />;
};

export default ServicePage;